export default "__VITE_ASSET__DTLwMZvV__"